import platforms from '../constants/platforms';

const GENERIC_PLATFORMS = new Set(['custom']);

const platformLabel = (platform) => {
  if (!platform || GENERIC_PLATFORMS.has(platform)) {
    return null;
  }
  return platforms.find((platformOption) => platformOption.value === platform)?.label ?? null;
};

export const generatedCouponLabels = (platform) => {
  const label = platformLabel(platform);
  if (!label) {
    return {
      tab: 'Generated Coupons',
      create: 'Create Generated Coupon',
      newCoupon: 'New Generated Coupon',
      reauthorize: 'Re-authorize Releva',
      store: 'your store',
    };
  }
  return {
    tab: `${label} Coupons`,
    create: `Create ${label} Coupon`,
    newCoupon: `New ${label} Coupon`,
    reauthorize: `Re-authorize Releva in ${label}`,
    store: `your ${label} store`,
  };
};

export default platformLabel;
